import React, { Component } from 'react';
import { Modal } from '../Modal/Modal';
import Portal from 'components/Portal/Portal';
import {noop} from 'utilities'

export default class MetaEditor extends Component{
  constructor(props){
    super();
    let pairs = Object.keys(props.pairs).map((key)=>(
      {key: key, value: props.pairs[key]}
    ))
    this.state = {modalOpen: false, pairs}
  }
  componentDidUpdate = (prevProps) => {
    if(prevProps.id !== this.props.id){
      let pairs = Object.keys(this.props.pairs).map((key)=>(
        {key: key, value: this.props.pairs[key]}
      ))
      this.setState({pairs})
    }
  }
  toggleModal = () => {
    this.setState({modalOpen: !this.state.modalOpen})
  }
  addPair = () => {
    let pairs = [...this.state.pairs, {key: "", value: ""}];
    this.setState({pairs})
  }
  setKey = (value, index) => {
    value = value.replace(" ", "_").replace("-", "_").toUpperCase();
    let pairs = [
      ...this.state.pairs.slice(0, index),
      {...this.state.pairs[index], key: value},
      ...this.state.pairs.slice(index + 1)
    ]
    this.setState({pairs});
  }
  setValue = (value, index) => {
    let pairs = [
      ...this.state.pairs.slice(0, index),
      {...this.state.pairs[index], value: value},
      ...this.state.pairs.slice(index + 1)
    ]
    this.setState({pairs});
  }
  save = () => {
    let pairs = {};
    this.state.pairs.map((pair, i) => {
      if(pair.key !== ""){
        pairs[pair.key] = pair.value;
      }return null
    })
    this.props.onChange(this.props.name, pairs);
  }
  deletePair = index => {
    let pairs = [
      ...this.state.pairs.slice(0, index),
      ...this.state.pairs.slice(index + 1)
    ]
    this.setState({ pairs })
  }
  render(){
    return(
      <div className="meta-editor block-wrapper">
        <button className="attribute-button" onClick={this.toggleModal}>{this.props.buttonLabel || "Edit Metadata"}</button>
        <Portal isOpened={this.state.modalOpen}>
          <Modal title="Edit Metadata" closeModal={this.toggleModal} modalSize="small" saveAndCloseButton={true} cancelButton={true} save={this.save} cancel={noop}>
            {
              this.state.pairs.length > 0 ?
              <div className="modal-head meta-head">
                <div className="head key-head">Key</div>
                <div className="head value-head">Value</div>
              </div>
              :
              null
            }
            <div className="block-wrapper padded pairs">
              {
              	this.state.pairs.map((pair, i) =>
              		<MetaPair
              			pair={pair}
              			pairIndex={i}
              			setKey={this.setKey}
              			setValue={this.setValue}
              			deletePair={this.deletePair}
              			isLast={i === 0 && this.state.pairs.length - 1 === 0}
              			key={i}
              		/>
              	)
              }
              <button className="add-pair" onClick={this.addPair}>+ Add New Meta Value</button>
            </div>
          </Modal>
        </Portal>
      </div>
    )
  }
}

class MetaPair extends Component{
  setKey= (e) => {
    this.props.setKey(e.target.value, this.props.pairIndex);
  }
  setValue = (e) => {
    this.props.setValue(e.target.value, this.props.pairIndex);
  }
  deletePair = () => {
    this.props.deletePair(this.props.pairIndex)
  }
  render(){
    const { isLast, pair } = this.props
    return(
      <div className="block-wrapper pair">
        <button className="delete-button" onClick={this.deletePair} disabled={isLast} tabIndex="-1" ><span className="icon icon-close"></span></button>
        <input type="text" className="key" placeholder="Key" onChange={this.setKey} value={pair.key} />
        <input type="text" className="value" placeholder="Value" onChange={this.setValue} value={pair.value} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Designer2/MetaEditor.js